/**
 * El desplegable «¿Cómo nos conoció?» de las pantallas del EQUIPO (23/9/2026):
 * la ficha (alta y «Editar»), el alta rápida del presupuesto y la LOPD manual.
 *
 * Obligatorio por decisión de dirección (23/9/2026): ver `lib/origenes.js`. Un
 * `<select>` nativo y no el de Radix, como en la LOPD del iPad: en Safari del
 * iPad el de Radix no responde bien al dedo dentro de un diálogo.
 *
 * El texto libre de antes («Recomendación») sale como «valor actual» y se
 * guarda tal cual si no se cambia: abrir una ficha no le borra el dato.
 *
 * Las opciones son las del catálogo VIGENTE (lo edita dirección), con las de
 * por defecto de respaldo si el servidor no contesta.
 */
import React from 'react';
import { Label } from './ui/label';
import {
  AVISO_FALTA_ORIGEN, faltaOrigen, opcionesComoNosConocio, useOpcionesComoNosConocio,
} from '../lib/origenes';

export default function CampoComoNosConocio({
  valor, onChange, onBlur, tocado, id = 'patient-how-known-us',
  testid = 'patient-how-known-us',
}) {
  const lista = useOpcionesComoNosConocio();
  const mal = !!tocado && faltaOrigen(valor);
  return (
    <div>
      <Label htmlFor={id}>
        ¿Cómo nos conoció?<span className="text-red-600"> *</span>
      </Label>
      <select
        id={id}
        value={String(valor ?? '').trim()}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        required
        aria-required
        aria-invalid={mal}
        className={`flex h-10 w-full rounded-md border bg-background px-3 py-2 text-sm ${mal ? 'border-red-300' : 'border-input'}`}
        data-testid={testid}
      >
        <option value="" disabled>Selecciona…</option>
        {opcionesComoNosConocio(valor, lista).map((o) => (
          <option key={o.valor} value={o.valor}>{o.etiqueta}</option>
        ))}
      </select>
      {mal && (
        <div className="text-xs text-red-600 mt-1" data-testid={`${testid}-error`}>
          {AVISO_FALTA_ORIGEN}
        </div>
      )}
    </div>
  );
}
